var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"concept"}},[_c('div',{staticClass:"contents"},[_c('BuildService',{attrs:{"visibleMovie":true}}),_c('Movie'),_c('CoreValue',{attrs:{"visibleMovie":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }